// This hook is responsible for fetching a single repository object by versionId.
import { gql, useLazyQuery } from "@apollo/client";

export const GET_REPOSITORY_OBJECT = gql`
  query getRepositoryObject($versionId: ID!) {
    getRepositoryObject(input: { versionId: $versionId }) {
      repositoryObject {
        repository {
          id
          name
          isStandard
          mainActivityId
        }
        name
        versionId
        revision
        md5Sum
        size
        createdAt
        createdBy
        comments {
          id
          text
          created
          createdBy
        }
        validity {
          qualityCheckStatus
          overallValidityStatus
          userValidityStatus
          systemValidityStatus
          outdatedUserValidityStatus
        }
      }
    }
  }
`;

export function useRepositoryObject() {
  const [
    callSingleRepositoryObject,
    { loading: isGetRepositoryObjectLoading, error: getRepositoryObjectError }
  ] = useLazyQuery(GET_REPOSITORY_OBJECT, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "no-cache"
  });

  return {
    callSingleRepositoryObject,
    isGetRepositoryObjectLoading,
    getRepositoryObjectError
  };
}
